module.exports = __webpack_public_path__ + "img/pin.03331291.png";